
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachNavigationVue from "@/components/coach/navigation.vue";
import CoachResourcesNavigationVue from "@/components/coach/resources/navigation.vue";
import AppCoachResourcesDietsListIndexVue from "@/views/app/coach/resources/diets/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    CoachNavigationVue,
    CoachResourcesNavigationVue,
    AppCoachResourcesDietsListIndexVue,
  },
})
export default class AppCoachResourcesDietsIndexVue extends Vue {}
